export default __webpack_public_path__ + "static/media/daniela_s.e20d4f2f.jpg";